import colors from "../../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  activeContributionBtn: {
    backgroundColor: colors.blue[100],
    border: "2px solid ".concat(colors.blue[600]),
    '&:hover': {
      border: "2px solid ".concat(colors.blue[600])
    }
  },
  contributionBtn: {
    padding: '2rem 4rem',
    color: colors.blue[600],
    minWidth: '26.8rem'
  },
  defaultContributionBtn: {
    backgroundColor: colors.neutral[100],
    '&:hover': {
      color: colors.blue[600]
    }
  },
  contributionDisclaimer: {
    fontStyle: 'italic',
    fontSize: '1.4rem',
    color: colors.green[600],
    textAlign: 'center',
    margin: '0.5rem 0'
  },
  contributionBtnWrapper: {
    width: 'fit-content',
    '&:not(:last-child)': {
      marginRight: '1.6rem'
    }
  },
  contributionBtnGuidelines: {
    maxWidth: '100%'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map